import type { ReloadStaticFormBasketRequest } from 'epic/advisory/basket/loadFormWithAdvisoryResult.epic';
import { CloneFormRequest } from 'epic/common-form/CloneFormRequest';
import { ReloadStaticFormRequest } from 'epic/static-form/fetch-when-quote-reprice';
import type { StaticProductCodesRequest } from 'epic/static-form/request-product-codes';
import { EnrichFormRequest } from 'models/forms/EnrichFormRequest';
import type { StaticFormResult } from 'models/forms/StaticFormResult';
import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import type { Observable } from 'rxjs';
import { ignoreElements, map } from 'rxjs/operators';
import type { IHttpClient as IOldHttpClient } from 'utils/http.old/httpClient.model';
import type { IHttpClient } from 'utils/http/httpClient.model';

export interface InitFormRequest {
  tabId: string;
  tradeDate: string;
  productType?: string;
  productSubType?: string;
  wrapper?: string;
  isPrivateMode?: boolean;
  currency?: string;
  selectedOnBehalfClient?: ISalesCounterpart;
  xMargin?: number;
}

export function staticFormApiConnectorLegacy(httpClient: IOldHttpClient) {
  const staticFormApi = 'api/v1/static-form/';

  return {
    initForm(request: InitFormRequest) {
      return httpClient
        .post<StaticFormResult>({ url: staticFormApi + 'init', body: request })
        .pipe(map(({ payload }) => payload));
    },
    enrichForm(request: EnrichFormRequest) {
      return httpClient
        .post<StaticFormResult>({ url: staticFormApi + 'modify', body: request })
        .pipe(map(({ payload }) => payload));
    },
    cloneForm(request: CloneFormRequest) {
      return httpClient
        .post<StaticFormResult>({ url: staticFormApi + `clone`, body: request })
        .pipe(map(({ payload }) => payload));
    },
    closeSession(id: string, productType: string, productSubtype: string) {
      return httpClient
        .delete<boolean>({
          url: staticFormApi + `session/${id}?${new URLSearchParams({ productType, productSubtype }).toString()}`,
        })
        .pipe(ignoreElements());
    },
    getStaticFormByIdType(request: ReloadStaticFormRequest) {
      const url = staticFormApi + 'reload';
      return httpClient.post<StaticFormResult>({ url, body: request }).pipe(map(({ payload }) => payload));
    },
    getFormFromAdvisoryResultByIdType(request: ReloadStaticFormBasketRequest) {
      const url = staticFormApi + `reload-basket`;
      return httpClient.post<StaticFormResult>({ url, body: request }).pipe(map(({ payload }) => payload));
    },
    generateProductCodes(request: StaticProductCodesRequest) {
      return httpClient
        .post<StaticFormResult>({ url: staticFormApi + 'compute-codes', body: request })
        .pipe(map(({ payload }) => payload));
    },
  };
}

export interface InitFromRequest {
  rfqId: string;
  tabId: string;
}

export interface InitFromApi {
  initFrom(request: InitFromRequest): Observable<StaticFormResult>;
}

type StaticFormApi = InitFromApi;

export function staticFormApiConnector(httpClient: IHttpClient): StaticFormApi {
  const staticFormApi = 'api/v1/static-form/';

  return {
    initFrom(request) {
      return httpClient
        .postJSON<StaticFormResult>({ url: staticFormApi + 'init-from', body: request })
        .pipe(map(({ payload }) => payload));
    },
  };
}
